/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserNotificationListResponse } from './RevisdomAPIViewModelsUserNotificationListResponse';
import {
    RevisdomAPIViewModelsUserNotificationListResponseFromJSON,
    RevisdomAPIViewModelsUserNotificationListResponseFromJSONTyped,
    RevisdomAPIViewModelsUserNotificationListResponseToJSON,
    RevisdomAPIViewModelsUserNotificationListResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserNotificationListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1NotificationListResponse
 */
export interface ApiResponse1NotificationListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1NotificationListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1NotificationListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserNotificationListResponse}
     * @memberof ApiResponse1NotificationListResponse
     */
    data?: RevisdomAPIViewModelsUserNotificationListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1NotificationListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1NotificationListResponse interface.
 */
export function instanceOfApiResponse1NotificationListResponse(value: object): value is ApiResponse1NotificationListResponse {
    return true;
}

export function ApiResponse1NotificationListResponseFromJSON(json: any): ApiResponse1NotificationListResponse {
    return ApiResponse1NotificationListResponseFromJSONTyped(json, false);
}

export function ApiResponse1NotificationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1NotificationListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserNotificationListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1NotificationListResponseToJSON(json: any): ApiResponse1NotificationListResponse {
    return ApiResponse1NotificationListResponseToJSONTyped(json, false);
}

export function ApiResponse1NotificationListResponseToJSONTyped(value?: ApiResponse1NotificationListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserNotificationListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

